import angular from 'angular';
import { SaveSearchService } from './save-search.service';
import { saveSearchInitializer } from './save-search.directive';

const MODULE_NAME = 'saveSearch';

export default angular
	.module(MODULE_NAME, [])
	.service('saveSearchService', SaveSearchService)
	.directive('saveSearchInitializer', saveSearchInitializer).name;
